import { Component, computed, inject, input} from '@angular/core';
import { Router } from '@angular/router';
import { Brand } from '../../../../../utils/models/layout.interface';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconInduxtryComponent } from '../../common/icon-induxtry/icon-induxtry.component';

@Component({
  selector: 'app-navigation-brand-logo',
  templateUrl: './navigation-brand-logo.component.html',
  styleUrls: ['./navigation-brand-logo.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    IconInduxtryComponent
  ],
})
export class NavigationBrandLogoComponent {
  brand = input<Brand>();
  collapse = input<boolean>();
  isNotCollapsed = computed<boolean>(() => this.collapse() || false);

  private readonly router = inject(Router);

  goHome(): void {
    this.router.navigateByUrl('/conexoes');
  }
}
